import ApplicantsActionTypes from 'redux/applicants/types';

export const fetchApplications = () => ({
  type: ApplicantsActionTypes.START_FETCH_APPLICANT_APPLICATION,
});

export const fetchApplicationsSuccess = (applications) => ({
  type: ApplicantsActionTypes.START_FETCH_APPLICANT_APPLICATION_SUCCESS,
  payload: applications,
});

export const fetchApplicationsFailure = (error) => ({
  type: ApplicantsActionTypes.START_FETCH_APPLICANT_APPLICATION_FAILURE,
  payload: error,
});

export const searchApplicantsApplications = (query) => ({
  type: ApplicantsActionTypes.SEARCH_APPLICANTS_APPLICATION_START,
  payload: query,
});

const candidateActionCreator = ({ type, ...payload }) => ({
  type,
  payload,
});

// NEW CANDIDATES
export const fetchCandidatesStart = ({ ...props }) =>
  candidateActionCreator({
    type: ApplicantsActionTypes.START_FETCH_APPLICANTS,
    ...props,
  });

export const fetchCandidatesSuccess = (candidates) => ({
  type: ApplicantsActionTypes.FETCH_APPLICANTS_SUCCESS,
  payload: candidates,
});

export const fetchCandidatesFailure = (error) => ({
  type: ApplicantsActionTypes.FETCH_APPLICANTS_FAILURE,
  payload: error,
});

// KEEP IN VIEW CANDIDATES
export const fetchKeepInViewCandidatesStart = ({ ...props }) =>
  candidateActionCreator({
    type: ApplicantsActionTypes.START_FETCH_KEEP_IN_VIEW_APPLICANTS,
    ...props,
  });

export const fetchKeepInViewCandidatesSuccess = (candidates) => ({
  type: ApplicantsActionTypes.FETCH_KEEP_IN_VIEW_APPLICANTS_SUCCESS,
  payload: candidates,
});

export const fetchKeepInViewCandidatesFailure = (error) => ({
  type: ApplicantsActionTypes.FETCH_KEEP_IN_VIEW_APPLICANTS_FAILURE,
  payload: error,
});

// ADMITTED CANDIDATES
export const fetchAdmittedCandidatesStart = ({ ...props }) =>
  candidateActionCreator({
    type: ApplicantsActionTypes.START_FETCH_ADMITTED_APPLICANTS,
    ...props,
  });

export const fetchAdmittedCandidatesSuccess = (candidates) => ({
  type: ApplicantsActionTypes.FETCH_ADMITTED_APPLICANTS_SUCCESS,
  payload: candidates,
});

export const fetchAdmittedCandidatesFailure = (error) => ({
  type: ApplicantsActionTypes.FETCH_ADMITTED_APPLICANTS_FAILURE,
  payload: error,
});

// DECLINED CANDIDATES
export const fetchDeclinedCandidatesStart = ({ ...props }) =>
  candidateActionCreator({
    type: ApplicantsActionTypes.START_FETCH_DECLINED_APPLICANTS,
    ...props,
  });

export const fetchDeclinedCandidatesSuccess = (candidates) => ({
  type: ApplicantsActionTypes.FETCH_DECLINED_APPLICANTS_SUCCESS,
  payload: candidates,
});

export const fetchDeclinedCandidatesFailure = (error) => ({
  type: ApplicantsActionTypes.FETCH_DECLINED_APPLICANTS_FAILURE,
  payload: error,
});

export const fetchApplicantFormStart = (id) => ({
  type: ApplicantsActionTypes.START_FETCH_APPLICANTS_FORM,
  payload: id,
});

export const fetchApplicantFormSuccess = (candidates) => ({
  type: ApplicantsActionTypes.FETCH_APPLICANTS_FORM_SUCCESS,
  payload: candidates,
});

export const fetchApplicantFormFailure = (error) => ({
  type: ApplicantsActionTypes.FETCH_APPLICANTS_FORM_FAILURE,
  payload: error,
});

export const fetchFormSchemaStart = (id, cb) => ({
  type: ApplicantsActionTypes.START_FETCH_FORM_SCHEMA,
  payload: { id, cb },
});

export const fetchFormSchemaSuccess = (candidates) => ({
  type: ApplicantsActionTypes.FETCH_FORM_SCHEMA_SUCCESS,
  payload: candidates,
});

export const fetchFormSchemaFailure = (error) => ({
  type: ApplicantsActionTypes.FETCH_FORM_SCHEMA_FAILURE,
  payload: error,
});

export const processApplicantStage = (candidate, status, filters, cb) => ({
  type: ApplicantsActionTypes.PROCESS_APPLICANT_STAGE,
  payload: { candidate, status, filters, cb },
});

export const processSuccessfulStageUpdate = () => ({
  type: ApplicantsActionTypes.PROCESS_SUCCESSFUL_STAGE_UPDATE,
});

export const processFailedStageUpdate = (error) => ({
  type: ApplicantsActionTypes.PROCESS_FAILED_STAGE_UPDATE,
  payload: error,
});

// notify applicants
export const notifyApplicants = (payload, cb) => ({
  type: ApplicantsActionTypes.NOTIFY_APPLICANT_START,
  payload: { payload, cb },
});

export const notifyApplicantsSuccess = () => ({
  type: ApplicantsActionTypes.NOTIFY_APPLICANT_SUCCESS,
});

export const notifyApplicantsFailure = (error) => ({
  type: ApplicantsActionTypes.NOTIFY_APPLICANT_FAILURE,
  payload: error,
});

// export data
export const exportApplicantsData = (data, cb) => ({
  type: ApplicantsActionTypes.EXPORT_APPLICANTS_DATA_START,
  payload: { data, cb },
});

export const exportApplicantsDataSuccess = () => ({
  type: ApplicantsActionTypes.EXPORT_APPLICANTS_DATA_SUCCESS,
});

export const exportApplicantsDataFailure = (error) => ({
  type: ApplicantsActionTypes.EXPORT_APPLICANTS_DATA_FAILURE,
  payload: error,
});

// batch process applicants
export const batchProcessApplicants = (data, cb) => ({
  type: ApplicantsActionTypes.BATCH_PROCESS_APPLICANT_STAGE,
  payload: { data, cb },
});

export const batchProcessSuccessfulStageUpdate = () => ({
  type: ApplicantsActionTypes.BATCH_PROCESS_SUCCESSFUL_STAGE_UPDATE,
});

export const batchProcessFailedStageUpdate = (error) => ({
  type: ApplicantsActionTypes.BATCH_PROCESS_FAILED_STAGE_UPDATE,
  payload: error,
});

// emailing applicant(s)
export const sendEmailToApplicants = (data, cb) => ({
  type: ApplicantsActionTypes.SEND_EMAIL_START,
  payload: { data, cb },
});

export const sendEmailToApplicantsSuccess = () => ({
  type: ApplicantsActionTypes.SEND_EMAIL_SUCCESS,
});

export const sendEmailToApplicantsFailed = (error) => ({
  type: ApplicantsActionTypes.SEND_EMAIL_FAILURE,
  payload: error,
});

export const sendSmsToApplicants = (data, cb) => ({
  type: ApplicantsActionTypes.SEND_SMS_START,
  payload: { data, cb },
});

export const sendSmsToApplicantsSuccess = () => ({
  type: ApplicantsActionTypes.SEND_SMS_SUCCESS,
});

export const sendSmsToApplicantsFailed = (error) => ({
  type: ApplicantsActionTypes.SEND_SMS_FAILURE,
  payload: error,
});

export const fetchCandidateEmails = (id) => ({
  type: ApplicantsActionTypes.FETCH_EMAIL_START,
  payload: id,
});

export const fetchCandidateEmailsSuccess = (data) => ({
  type: ApplicantsActionTypes.FETCH_EMAIL_SUCCESS,
  payload: data,
});

export const fetchCandidateEmailsFailed = (error) => ({
  type: ApplicantsActionTypes.FETCH_EMAIL_FAILURE,
  payload: error,
});

// pre-loaded candidates
export const fetchPreloadedCandidatesStats = (data) => ({
  type: ApplicantsActionTypes.FETCH_PRELOADED_STATS_START,
  payload: data,
});

export const fetchPreloadedCandidatesStatsSuccess = (stats) => ({
  type: ApplicantsActionTypes.FETCH_PRELOADED_STATS_SUCCESS,
  payload: stats,
});

export const fetchPreloadedCandidatesStatsFailed = (error) => ({
  type: ApplicantsActionTypes.FETCH_PRELOADED_STATS_FAILURE,
  payload: error,
});

// transactions
export const fetchCandidateTransactions = ({ candidateId }) => ({
  type: ApplicantsActionTypes.FETCH_APPLICANT_TRANSACTIONS_START,
  payload: { candidateId },
});

export const fetchCandidateTransactionsSuccess = (data) => ({
  type: ApplicantsActionTypes.FETCH_APPLICANT_TRANSACTIONS_SUCCESS,
  payload: data,
});

export const fetchCandidateTransactionsFailed = (error) => ({
  type: ApplicantsActionTypes.FETCH_APPLICANT_TRANSACTIONS_FAILURE,
  payload: error,
});
